var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShiping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shiping",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_7",
    "data-name": "Rect\\xE1ngulo 7",
    width: 20.38,
    height: 16.37,
    transform: "translate(0 0)",
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_23",
    "data-name": "Rect\\xE1ngulo 23",
    width: 24,
    height: 24,
    fill: "white",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13",
    "data-name": "Grupo 13",
    transform: "translate(2 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12",
    "data-name": "Grupo 12",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M19.862,7.224,18.833,5.8A2.748,2.748,0,0,0,16.6,4.64h-4.13V2.75A2.753,2.753,0,0,0,9.719,0H2.75A2.753,2.753,0,0,0,0,2.75v9.94a1.753,1.753,0,0,0,1.75,1.75H2.761a2.492,2.492,0,0,0,4.856,0h5.144a2.493,2.493,0,0,0,4.857,0h1.011a1.752,1.752,0,0,0,1.75-1.75V8.82a2.768,2.768,0,0,0-.517-1.6m-.983,1.6v3.87a.253.253,0,0,1-.25.25H17.515a2.507,2.507,0,0,0-4.65,0h-.4V6.14H16.6a1.272,1.272,0,0,1,1.017.526l1.027,1.426a1.285,1.285,0,0,1,.236.728m-3.69,6.3A.937.937,0,0,1,15.1,15.1a1.228,1.228,0,0,1-1.158-1.231c0-.035.018-.065.021-.1a1.245,1.245,0,0,1,1.073-1.119,1.2,1.2,0,0,1,.156-.032,1.25,1.25,0,0,1,0,2.5M10.969,2.75V12.94H7.515a2.507,2.507,0,0,0-4.651,0H1.75a.25.25,0,0,1-.25-.25V2.75A1.251,1.251,0,0,1,2.75,1.5H9.719a1.251,1.251,0,0,1,1.25,1.25M5.189,15.12A.937.937,0,0,1,5.1,15.1,1.228,1.228,0,0,1,3.939,13.87c0-.035.017-.065.02-.1a1.247,1.247,0,0,1,1.074-1.119,1.166,1.166,0,0,1,.156-.032,1.25,1.25,0,1,1,0,2.5",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11",
    "data-name": "Trazado 11",
    d: "M16.219,7.14h-2a.75.75,0,0,0,0,1.5h2a.75.75,0,0,0,0-1.5",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiping);
export default __webpack_public_path__ + "static/media/shiping.1db814fff778badd4c22fbd21ae26500.svg";
export { ForwardRef as ReactComponent };